import { ConfigType, Dayjs } from 'dayjs';

export { ConfigType, Dayjs };
